import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import useQueryGetOtpProviders from '@/modules/otp-provider/api/hooks/useQueryGetOtpProviders'
import OtpProviderListing from '@/modules/otp-provider/components/OtpProviderListing'

function OtpProvidersPage() {
	const { data, isLoading } = useQueryGetOtpProviders()

	return (
		<PageContainer>
			<OtpProviderListing data={data || []} isLoading={isLoading} />
		</PageContainer>
	)
}

export default withUserPermission(OtpProvidersPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.WEB_SETTING],
})
